/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source SVG file at
 * `src/shared/joykit/packages/core/icons/svgs/<SIZE>/travel-flight.svg`, and run `yarn icon:codegen` to regenerate this file.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Travel Flight',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <path
            d="M3.593 6.586l6.94 4.396-3.093 3.71-2.796-.56-1.34 1.34 3.37 2.075 2.075 3.37 1.34-1.34-.56-2.796 3.71-3.093 4.396 6.94.718-.718a2 2 0 0 0 .493-2.016l-2.323-7.363 3.724-3.915a1.87 1.87 0 0 0-.033-2.613 1.87 1.87 0 0 0-2.613-.033L13.69 7.697 6.328 5.374a2 2 0 0 0-2.016.493l-.718.718z"
            fill="transparent"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinejoin="round"
          ></path>
        </>
      )
    },
    '48': {
      viewBox: '0 0 48 48',
      path: (
        <>
          <path
            fillRule="evenodd"
            d="M39.623 8.377a3.05 3.05 0 0 0-4.258-.053l-7.686 7.311c-.165.157-.402.212-.619.143l-15.572-4.912c-.489-.154-1.023-.024-1.386.339L8.416 12.89l12.968 8.213c.152.096.283.431.283.431s-.022.359-.137.497l-6.073 7.287c-.147.176-.378.258-.603.213l-5.161-1.034-1.833 1.833 5.945 3.66c.083.051.153.121.205.205l3.66 5.945 1.833-1.833-1.034-5.161c-.045-.225.037-.456.213-.603l7.286-6.073c.138-.115.319-.165.497-.137s.335.131.431.283l8.213 12.968 1.685-1.685c.363-.363.493-.897.339-1.386l-4.912-15.572c-.068-.217-.014-.454.143-.619l7.311-7.687a3.05 3.05 0 0 0-.053-4.258zm-5.12-.959a4.3 4.3 0 0 1 6.079 6.079l-7.057 7.419 4.801 15.221c.294.934.045 1.954-.647 2.646l-2.237 2.237c-.134.134-.322.2-.511.179s-.358-.126-.459-.287l-8.25-13.026-6.453 5.379 1.027 5.124c.041.205-.023.417-.171.565l-2.629 2.629c-.135.135-.325.201-.515.179s-.359-.13-.459-.293l-3.997-6.492-6.492-3.997c-.163-.1-.271-.27-.293-.459s.044-.38.179-.515l2.629-2.629c.148-.148.36-.212.565-.171l5.124 1.026 5.379-6.454-13.026-8.25c-.16-.102-.266-.271-.287-.459s.045-.377.179-.511l2.237-2.237c.692-.692 1.712-.942 2.646-.647l15.221 4.801 7.419-7.057z"
            fill="currentColor"
          />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
